import { Route, Routes, useParams } from 'react-router-dom'
import Section from 'app/frontend/base/components/Section'
import { useGuild } from 'app/frontend/base/config/context/guild'
import {
  useGuildNewsItem,
  useGuildNewsItems,
} from 'app/frontend/base/config/queries'
import { uploadGuildFile } from 'app/frontend/base/api/guild'
import NewsIndex from 'app/frontend/base/pages/shared/News/NewsIndex'
import NewsForm from 'app/frontend/base/pages/shared/News/NewsForm'
import NewsView from 'app/frontend/base/pages/shared/News/NewsView'

const guildNewsPermission = {
  section: 'base',
  requirement: 'admin',
  requireAllTeams: true,
} as const

const GuildNewsIndex = () => {
  const { guild } = useGuild()
  const { data: newsItems, isPending } = useGuildNewsItems(guild?.id)

  return (
    <NewsIndex
      newsItems={newsItems}
      isPending={isPending}
      createPermission={guildNewsPermission}
      editPermissionForItem={() => guildNewsPermission}
    />
  )
}

const GuildNewsForm = () => {
  const { guild } = useGuild()
  const { id } = useParams()
  const newsItemId = id ? parseInt(id) : undefined
  const { data: existingItem, isPending } = useGuildNewsItem(
    guild?.id,
    newsItemId,
  )

  if (!guild) return null

  return (
    <NewsForm
      parentEntityType='guild'
      parentId={guild.id}
      existingItem={existingItem}
      isPending={isPending}
      listQueryKey={['guildNewsItems', { guildId: guild.id }]}
      uploadFile={async (file) => (await uploadGuildFile(guild.id, file)).url}
      showTargetSelector={false}
      formPermission={() => guildNewsPermission}
    />
  )
}

const GuildNewsView = () => {
  const { guild } = useGuild()
  const { id } = useParams()
  const newsItemId = id ? parseInt(id) : undefined
  const { data: newsItem, isPending } = useGuildNewsItem(guild?.id, newsItemId)

  return (
    <NewsView
      newsItem={newsItem}
      isPending={isPending}
      editPermission={guildNewsPermission}
    />
  )
}

const GuildNewsRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<GuildNewsIndex />} />
      <Route path='/new' element={<GuildNewsForm />} />
      <Route path='/:id' element={<GuildNewsView />} />
      <Route path='/:id/edit' element={<GuildNewsForm />} />
    </Routes>
  )
}

const GuildNews = () => {
  const { guild } = useGuild()

  return (
    <Section title={`News | ${guild?.name}`}>
      <GuildNewsRoutes />
    </Section>
  )
}

export default GuildNews
